import React from "react";
import "./ExpenseForm.scss";
import TextFormField from "~/components/text-form-field";
import { FormProps } from "./CommonTypes";
import { ExpenseFormWrapper } from "./ExpenseFormWrapper";
import EnumDropdownFormField from "~/visuals/organisms/EnumDropdownFormField";
import { EeCodePickerFormField } from "~/visuals/organisms/EeCodePickerFormField";
import { AtvExpense, OwnerInformationLabels } from "~/gql/types";

type AtvFormProps = FormProps & {
  expenseEntry?: AtvExpense;
};

const AtvTypeForm: React.FC<AtvFormProps> = (props) => {
  return (
    <ExpenseFormWrapper {...{ ...props, typeName: "ATV Expense" }}>
      <EeCodePickerFormField
        label="EE Code"
        formField="eeCode"
        helperText="The ee code applicable to this work. (use up/down arrows and enter key to select suggestions)"
        required
      />
      <EnumDropdownFormField
        label="Owner Information"
        formField="ownerInformation"
        helperText="The owner of the ATV"
        options={OwnerInformationLabels}
        required
      />
      <TextFormField label="Notes" helperText="" formField="notes" textarea />
    </ExpenseFormWrapper>
  );
};

export default AtvTypeForm;
